'use strict';

require('./Uploader.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    uploadcare = require('uploadcare-widget');

const Uploader = React.createClass({displayName: "Uploader",

    propTypes: {
        label: PropTypes.string,
        isDisabled: PropTypes.bool,
        onChange: PropTypes.func,
        onUploadComplete: PropTypes.func,
        imgSrc: PropTypes.func
    },

    componentDidMount() {
        uploadcare.start({
            publicKey: '5571fda16e2a7f7cd8b5',
            tabs: 'all',
            crop: '64x64',
            live: true,
            previewStep: true
        });

        const {onChange, onUploadComplete} = this.props;
        const widget = uploadcare.Widget('[role=uploadcare-uploader]'); // get internal reference element

        if (onChange) {
            widget.onChange(onChange);

        }
        if (onUploadComplete) {
            widget.onUploadComplete(onUploadComplete);
        }
    },

    getValue() {
        return this.refs.inputFile.getDOMNode().value;
    },

    setValue(newValue) {
        this.refs.inputFile.getDOMNode().value = newValue;
    },

    render() {
        const inputEl = this.props.isDisabled === true ? (
                React.createElement("input", {ref: "inputFile", 
                       type: "hidden", 
                       "data-public-key": "5571fda16e2a7f7cd8b5", 
                       role: "uploadcare-uploader", 
                       name: "uploadcare-uploader-name", 
                       id: "uploader-image-id", 
                       disabled: true}
                )
            ) :
            (
                React.createElement("input", {ref: "inputFile", 
                       type: "hidden", 
                       "data-public-key": "5571fda16e2a7f7cd8b5", 
                       role: "uploadcare-uploader", 
                       name: "uploadcare-uploader-name", 
                       id: "uploader-image-id", 
                       onChange: this.props.onChange}
                )
            );

        return (
            React.createElement("div", {className: "uploader"}, 
                React.createElement("label", {className: "uploader uploader__label pull-left", for: "uploader-image-id"}, this.props.label), 
                inputEl
            )
        );
    }
});

module.exports = Uploader;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Uploader/Uploader.js
 **/